   const firebaseConfig = {
    // apiKey: "AIzaSyAf1iQ0RQuGXc6G_6RC1ai4Grp_NIyGPUo",
    // authDomain: "simple-client-site.firebaseapp.com",
    // projectId: "simple-client-site",
    // storageBucket: "simple-client-site.appspot.com",
    // messagingSenderId: "702085315458",
    // appId: "1:702085315458:web:6c336ff2bcff9d36e9ed9b"
  
  
    apiKey:"AIzaSyAcY5N-FBc4r2q5JqaHyqqauZ9_6tAlTdw",
    authDomain:"simple-car-seller-site.firebaseapp.com",
    projectId:"simple-car-seller-site",
    storageBucket:"simple-car-seller-site.appspot.com",
    messagingSenderId:"737958389170",
    appId:"1:737958389170:web:fa5fbce4b29accefa230ab"
  };
  export default firebaseConfig;